import { getCookie } from '@api/HelperAPI';
import { TFormalOffer } from '@helpers/FormalOffers/formalOffers.types';
import { getIsRCFOffer } from '@helpers/FormalOffers/getIsRCFOffer';

import { RCF_CASHLESS_OPENING_COOKIE } from '../myOffers/approvedView/RCFApprovedView/RCFApprovedView';

export const getDrawdownType = (formalOffer: TFormalOffer) => {
    if (formalOffer.is_repayment_reduction) return 'repayment_reduction';
    else if (getIsRCFOffer(formalOffer)) {
        if (!formalOffer.is_funded) {
            if (getCookie(RCF_CASHLESS_OPENING_COOKIE) === 'true') {
                return 'revolving_credit_facility_cashless_activation';
            }
            return 'revolving_credit_facility_first_drawdown';
        }

        return 'revolving_credit_facility_drawdown';
    } else if (
        formalOffer.interest_only_repayments &&
        formalOffer.interest_only_repayments > 0 &&
        formalOffer.available_cash === 0
    ) {
        return 'interest_only_extension';
    } else {
        return 'topup';
    }
};
